import { BASEURL } from "../constants";
import axios from "axios";
import { gotoLogin } from "./auth";

const JSONbigString = require("json-bigint")({ storeAsString: true });
// 响应状态集合
const showStatus = (status: number) => {
  let message = "";
  switch (status) {
    case 400:
      message = "请求错误(400)";
      break;
    case 401:
      message = "未授权，请重新登录(401)";
      break;
    case 403:
      message = "拒绝访问(403)";
      break;
    case 404:
      message = "请求出错(404)";
      break;
    case 408:
      message = "请求超时(408)";
      break;
    case 500:
      message = "服务器错误(500)";
      break;
    case 501:
      message = "服务未实现(501)";
      break;
    case 502:
      message = "网络错误(502)";
      break;
    case 503:
      message = "服务不可用(503)";
      break;
    case 504:
      message = "网络超时(504)";
      break;
    case 505:
      message = "HTTP版本不受支持(505)";
      break;
    default:
      message = `连接出错(${status})!`;
  }
  return `${message}，请检查网络或联系管理员！`;
};

const getHeaders = () => {
  return {
    "content-type": "application/json",
    token: localStorage.getItem("idmToken"),
    appId: "asleads",
    loginType: "idm",
  };
};

export const requestKong = axios.create({
  responseType: "json", // 返回数据类型
  timeout: 5 * 60 * 1000,
});

// 请求拦截
requestKong.interceptors.request.use(
  (config: any) => {
    return config;
  },
  (error) => Promise.resolve(error)
);

// 响应拦截
requestKong.interceptors.response.use(
  (response) => {
    const status = response.status;
    let msg = "";
    if (status < 200 || status >= 300) {
      // 处理http错误，抛到业务代码
      msg = showStatus(status);
      if (typeof response.data === "string") {
        response.data = { msg };
      } else {
        response.data.msg = msg;
      }
    }
    if (response?.data?.resultCode == 5002) {
      gotoLogin();
      return Promise.reject(response?.data);
    }
    return response;
  },
  (error) => {
    console.log("interceptors response error :>> ", error);
    Promise.reject(error);
  }
);

// 请求封装
export function ajax({
  method,
  url,
  data = {},
  type = "json",
  needResponse = false,
  config = {},
  params = {},
  baseURL = "",
}: any) {
  let contentType = "";
  // let currentUrl =
  //   process.env.NODE_ENV === "development" ? "/baseAddress" : BASEURL;
  let currentUrl = BASEURL;
  // debugger;
  if (baseURL) {
    currentUrl = baseURL;
  }
  if (type === "json") {
    contentType = "application/json;charset=utf-8";
  } else if (type === "form") {
    contentType = "multipart/form-data";
  } else {
    contentType = "application/x-www-form-urlencoded;charset=utf-8";
  }
  let typeData = {};
  if (method === "get") {
    typeData = { params: { ...data, ...params } };
  } else {
    typeData = { params, data };
  }
  return new Promise((resolve, reject) => {
    requestKong({
      method,
      url,
      ...typeData,
      headers: getHeaders(),
      ...config,
      baseURL: currentUrl,
      transformResponse: [
        function (data) {
          // 对 data 进行任意转换处理
          try {
            return JSONbigString.parse(data);
          } catch (err) {
            return data;
          }
        },
      ],
    })
      .then((res) => {
        const result = needResponse ? res : res.data;
        return resolve(result);
      })
      .catch((err) => {
        return reject(err.data);
      });
  });
}

// post请求封装
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} type [请求时content-type的类型]
 */
export function post({
  url,
  data,
  type,
  needResponse,
  config,
  params,
  baseURL,
}: any) {
  return ajax({
    method: "post",
    url,
    data,
    type,
    needResponse,
    config,
    params,
    baseURL,
  });
}

// get请求封装
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} type [请求时content-type的类型]
 */
export function get({
  url,
  data,
  type,
  needResponse,
  config,
  params,
  baseURL,
}: any) {
  return ajax({
    method: "get",
    url,
    data,
    type,
    needResponse,
    config,
    params,
    baseURL,
  });
}
